module.exports = __webpack_public_path__ + "img/icon-department.d13838b2.svg";